import React  from "react";
import "../App.css";

function Header(props) {
   
  return (
      <div className="mainNav">
         <center><p className="brand">Type-Me</p></center>
      </div>
  );
}

export default Header;
